import { render, staticRenderFns } from "./SubmissionAddStep4.vue?vue&type=template&id=0031c94b"
import script from "./SubmissionAddStep4.vue?vue&type=script&lang=js"
export * from "./SubmissionAddStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports